
import { Component, Prop, Vue } from 'vue-property-decorator';
import Tooltip from './Tooltip.vue';

interface Option {
	text?: string;
	value?: string | number;
	showLock?: boolean;
	showTooltip?: boolean;
	tooltipText?: string;
	tooltipIcon?: string;
	locked?: boolean;
	disabled?: boolean;
}

@Component({
	components: {
		Tooltip
	}
})
export default class ScrollableButtonGroup extends Vue {
	@Prop({ type: [String, Number], required: true }) readonly value!: string | number;
	@Prop({ type: Array, required: true }) readonly options!: (Option | string | number)[];
	@Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
	@Prop({ type: String, default: 'order-type' }) readonly idPrefix!: string;

	private showLeftButton = false;
	private showRightButton = false;

	private get selectedValue(): string | number {
		return this.value;
	}

	private set selectedValue(newValue: string | number) {
		this.$emit('input', newValue);
	}

	private mounted() {
		this.checkOverflow();
		window.addEventListener('resize', this.checkOverflow);
	}

	private beforeDestroy() {
		window.removeEventListener('resize', this.checkOverflow);
	}

	private checkOverflow() {
		this.$nextTick(() => {
			const container = this.$refs.scrollWrapper as HTMLElement;
			if (container) {
				this.updateScrollButtons(container);
			}
		});
	}

	private checkScroll() {
		const container = this.$refs.scrollWrapper as HTMLElement;
		this.updateScrollButtons(container);
	}

	private updateScrollButtons(container: HTMLElement) {
		this.showLeftButton = container.scrollLeft > 0;
		this.showRightButton = container.scrollLeft + container.clientWidth + 1 < container.scrollWidth;
	}

	private scrollLeft() {
		const container = this.$refs.scrollWrapper as HTMLElement;
		container.scrollBy({ left: -250, behavior: 'smooth' });
		this.checkScroll();
	}

	private scrollRight() {
		const container = this.$refs.scrollWrapper as HTMLElement;
		container.scrollBy({ left: 250, behavior: 'smooth' });
		this.checkScroll();
	}

	private emitChange(newValue: string | number) {
		this.$emit('input', newValue);
		this.$emit('change', newValue);
	}

	private scrollToCenter(event: Event) {
		const container = this.$refs.scrollWrapper as HTMLElement;
		const button = (event.target as HTMLElement).closest('button');
		if (!button) {
			return;
		}

		const containerRect = container.getBoundingClientRect();
		const buttonRect = button.getBoundingClientRect();

		const scrollLeft = buttonRect.left + buttonRect.width / 2 - (containerRect.left + containerRect.width / 2);

		container.scrollBy({
			left: scrollLeft,
			behavior: 'smooth'
		});

		this.checkScroll();
	}
}
